<template>
  <div>
    <Dialog
      :visible.sync="lostDialog1"
      :style="{ width: '700px', height: '387px', overflowY: 'auto' }"
      header="Lost Status Box"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mbpBranch">Reason</label>
          <Dropdown
            :showClear="true"
            v-model="reason"
            :options="reasons"
            optionLabel="lqNoteDesc"
            dataKey="id"
            placeholder="Select Reason"
            autofocus
          />
          <small class="p-invalid" v-if="submitted && !(reason && reason.id)"
            >Reason is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="a">Please give details below</label>
          <InputText id="a" v-model.trim="comment" />
          <small class="p-invalid" v-if="submitted && !comment"
            >Comment is required.</small
          >
        </div>
      </div>
      <br />
      <br />
      <br />

      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              style="width: 100px;"
              @click="$emit('close')"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <ProgressSpinner
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;"
              strokeWidth="5"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              style="width: 100px;"
              @click="save"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";

export default {
  created() {
    this.quotationService
      .getLostStatusReasons()
      .then(data => (this.reasons = data))
      .catch(e => {
        if (e.response.status !== 200)
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting lost status reasons.",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeLostQuoteNotes"'
          });
      });
  },
  props: {
    lostDialog: {
      type: Boolean,
      required: true
    },
    reload: {
      type: Number,
      required: false
    },
    sendingRequest: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    quotationService: new QuotationService(),
    comment: "",
    submitted: false,
    reasons: [],
    reason: {}
  }),
  watch: {
    reload(val) {
      this.comment = "";
      this.reason = {};
      this.submitted = false;
    }
  },
  computed: {
    lostDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        if (this.lostDialog) {
          this.comment = "";
          this.reason = {};
        }
        return this.lostDialog;
      }
    }
  },
  methods: {
    save() {
      this.submitted = true;
      if (this.comment && this.reason && this.reason.id)
        this.$emit("save", {
          reason: this.reason,
          comment: this.comment
        });
    }
  }
};
</script>

<style></style>
